export function initAnchorNav() {
    var lastBarsHeight = null;
    var MD_BREAKPOINT  = 600;

    function isDesktop() {
        return window.innerWidth >= MD_BREAKPOINT;
    }

    function updateAnchorTop(animate) {
        // On mobile, remove any previously set inline top and bail out.
        if (!isDesktop()) {
            document.querySelectorAll('[data-anchor-sticky]').forEach(function (el) {
                el.style.transition = '';
                el.style.top = '';
            });
            lastBarsHeight = null;
            updateScrollOffset();
            return;
        }

        var bars = document.getElementById('sticky-top-bars');
        var height = bars ? bars.getBoundingClientRect().height : 0;

        // Skip non-animated updates when height hasn't changed.
        // Prevents ResizeObserver from cancelling a MutationObserver-triggered transition.
        if (!animate && height === lastBarsHeight) return;
        lastBarsHeight = height;

        document.querySelectorAll('[data-anchor-sticky]').forEach(function (el) {
            el.style.transition = animate ? 'top 300ms ease-in-out' : '';
            el.style.top = height + 'px';
        });

        updateScrollOffset();
    }

    // Sets scroll-margin-top on every block section to the combined height of
    // the sticky bars + sticky anchor nav, so anchor-link scrolling always
    // lands just below all sticky headers.
    function updateScrollOffset() {
        if (!isDesktop()) {
            document.querySelectorAll('section[id^="block-"]').forEach(function (section) {
                section.style.scrollMarginTop = '';
            });
            return;
        }

        var bars = document.getElementById('sticky-top-bars');
        var anchorSection = document.querySelector('[data-anchor-sticky]');
        var barsH = bars ? bars.getBoundingClientRect().height : 0;
        var anchorH = anchorSection ? anchorSection.getBoundingClientRect().height : 0;
        var total = barsH + anchorH;
        document.querySelectorAll('section[id^="block-"]').forEach(function (section) {
            section.style.scrollMarginTop = total + 'px';
        });
    }

    updateAnchorTop(false);

    var barsEl = document.getElementById('sticky-top-bars');
    if (barsEl) {
        // ResizeObserver fires after layout recalculation, so getBoundingClientRect()
        // always returns the correct post-resize value — covers all breakpoint changes.
        new ResizeObserver(function () { updateAnchorTop(false); }).observe(barsEl);

        new MutationObserver(function () { updateAnchorTop(true); }).observe(barsEl, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'style', 'hidden'],
            childList: true,
        });
    }

    const nav = document.querySelector('[data-anchor-nav]');
    if (!nav) return;

    // Re-measure scroll offset when the anchor nav section itself resizes
    // (e.g. items wrap onto a second line at narrow viewports).
    var anchorSectionEl = document.querySelector('[data-anchor-sticky]');
    if (anchorSectionEl) {
        new ResizeObserver(updateScrollOffset).observe(anchorSectionEl);
    }

    const scrollEl = nav.querySelector('[data-anchor-scroll]');
    const prevBtn  = nav.querySelector('.c_swiper-anchorblock-prev');
    const nextBtn  = nav.querySelector('.c_swiper-anchorblock-next');

    if (scrollEl && prevBtn && nextBtn) {
        function scrollStep() {
            return (scrollEl.querySelector('li')?.offsetWidth ?? 120) + 8;
        }

        function updateArrows() {
            const overflows = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
            const atStart   = scrollEl.scrollLeft <= 0;
            const atEnd     = Math.ceil(scrollEl.scrollLeft + scrollEl.clientWidth) >= scrollEl.scrollWidth;
            prevBtn.classList.toggle('invisible', !overflows || atStart);
            nextBtn.classList.toggle('invisible', !overflows || atEnd);
        }

        prevBtn.addEventListener('click', function () {
            scrollEl.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', function () {
            scrollEl.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });

        scrollEl.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', function () {
            updateArrows();
            updateAnchorTop(false);
        });
        updateArrows();
    }

    const links = Array.from(nav.querySelectorAll('a[href^="#block-"]'));
    if (!links.length) return;

    function scrollNavToIndex(index) {
        if (!scrollEl) return;
        const activeItem    = links[index].parentElement;
        const containerRect = scrollEl.getBoundingClientRect();
        const itemRect      = activeItem.getBoundingClientRect();
        const itemLeft      = scrollEl.scrollLeft + itemRect.left - containerRect.left;
        const targetScroll  = itemLeft - scrollEl.clientWidth / 2 + itemRect.width / 2;
        scrollEl.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    // Suppresses scroll-based tracking while a click-initiated scroll is running.
    let isClickScrolling    = false;
    let clickScrollFallback = null;
    let scrollTimer         = null;

    links.forEach(function (link, index) {
        link.addEventListener('click', function () {
            links.forEach(function (l) { l.classList.remove('!bg-peach'); });
            link.classList.add('!bg-peach');
            scrollNavToIndex(index);

            // Block scroll tracking until the auto-scroll finishes.
            isClickScrolling = true;
            clearTimeout(clickScrollFallback);
            // Fallback: re-enable tracking if scrollend never fires (older browsers).
            clickScrollFallback = setTimeout(function () {
                isClickScrolling = false;
            }, 3000);
        });
    });

    function updateActiveState() {
        var stickyBars   = document.getElementById('sticky-top-bars');
        var stickyAnchor = document.querySelector('[data-anchor-sticky]');
        var stickyH      = (stickyBars   ? stickyBars.getBoundingClientRect().height   : 0)
                         + (stickyAnchor ? stickyAnchor.getBoundingClientRect().height : 0);
        const threshold  = stickyH + 1;
        let activeId    = null;
        let activeIndex = -1;

        let bestTop = -Infinity;
        links.forEach(function (link, index) {
            const section = document.getElementById(link.getAttribute('href').substring(1));
            if (section) {
                const top = section.getBoundingClientRect().top;
                if (top <= threshold && top > bestTop) {
                    bestTop     = top;
                    activeId    = section.id;
                    activeIndex = index;
                }
            }
        });

        links.forEach(function (link) {
            const id = link.getAttribute('href').substring(1);
            link.classList.toggle('!bg-peach', id === activeId);
        });

        if (activeIndex !== -1) {
            scrollNavToIndex(activeIndex);
        }
    }

    window.addEventListener('scroll', function () {
        if (isClickScrolling) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateActiveState, 150);
    }, { passive: true });

    // When the auto-scroll finishes, lift the suppression so manual scroll
    // tracking resumes. Do NOT call updateActiveState() here — the click
    // handler already set the correct active link.
    window.addEventListener('scrollend', function () {
        clearTimeout(clickScrollFallback);
        isClickScrolling = false;
    }, { passive: true });

    updateActiveState();
}
